

























import Vue from "vue";

import {
  CHAT_LABEL_DICTATION_CORRECT,
  propsDefHasSpeakerIcon
} from "../../constants/chat";
import { PropsHasSpeakerIcon } from "../../models/chat";

interface Props extends PropsHasSpeakerIcon {
  msgCorrectLabel: string;
  text: string;
}

/**
 * This special message is only available during exercise review
 *
 * Note: the `jz-speaker-icon` is redundant with JzChatMsg speaker icon.
 * However, for the sake of keeping this component functional, the
 * template code is duplicated. CSS can be factorized with mixins
 */
export default Vue.extend<Props>({
  name: "JzChatDictationReview",
  functional: true,

  props: {
    ...propsDefHasSpeakerIcon,
    msgCorrectLabel: { type: String, default: CHAT_LABEL_DICTATION_CORRECT },
    text: { type: String, required: true }
  }
});
